// src/pages/Login.jsx
import { useNavigate } from 'react-router-dom';
import { auth } from '@/services/firebase';
import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';

export function LoginPage() {
  const navigate = useNavigate();

  const handleGoogleSignIn = async () => {
    try {
      const provider = new GoogleAuthProvider();
      await signInWithPopup(auth, provider);
      // Always navigate to home after login
      navigate('/', { replace: true });
    } catch (error) {
      console.error('Login error:', error);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background-dim">
      <div className="w-full max-w-md space-y-8 rounded-lg bg-white p-6 shadow-lg">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900">
            Welcome to SourceLink
          </h2>
          <p className="mt-2 text-gray-600">Please sign in to continue</p>
        </div>
        <button
          onClick={handleGoogleSignIn}
          className="flex w-full items-center justify-center gap-3 rounded-lg bg-white px-4 py-2 text-gray-700 shadow-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:ring-offset-2">
          <img src="/img/google.svg" alt="Google" className="h-6 w-6" />
          Sign in with Google
        </button>
      </div>
    </div>
  );
}
